import { createFileRoute } from '@tanstack/react-router';
import { CampaignTasks } from '@/pages';

/**
 * Campaign Tasks Route (Protected)
 * Review hub for the one-off creator flow: required tasks + content requirements.
 */
export const Route = createFileRoute('/_authenticated/campaign/$id/tasks')({
  component: CampaignTasks,
});
